module.exports = __webpack_public_path__ + "img/Features_Company.9797221e.webp";